import React from 'react';
import { CostsAndCharges } from './pages/CostsAndCharges';
export function App() {
  return <main className="w-full min-h-screen" data-id="element-0">
      <CostsAndCharges data-id="element-1" />
    </main>;
}